import { utils } from 'alelo-logic'

export const validateTag = (value, allValues) => {
  if (!allValues.validPlate || allValues.validPlate === '') {
    if (!value) return 'A tag é obrigatório.'
    if (value.length !== 10) return 'Tag inválida.'
  }
  return undefined
}

export const validatePlate = (value, allValues) => {
  if (!allValues.identificador || allValues.identificador === '') {
    return utils.plateValidate(value)
  }
  return undefined
}



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/FilterByTag/utils.js